module.exports = __webpack_public_path__ + "img/session.f44b59ac.png";